export default __webpack_public_path__ + "static/media/6.3f06b63c.webp";